module.exports = __webpack_public_path__ + "static/media/Barsha Bhattacharya.4899569e.jpeg";